import script from "./index1.vue?vue&type=script&setup=true&lang=js"
export * from "./index1.vue?vue&type=script&setup=true&lang=js"

import "./index1.vue?vue&type=style&index=0&id=34d612bf&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34d612bf"]])

export default __exports__